import { create } from "zustand";
import { ApplicationStore, ApplicationStoreProps } from "../types";

export const useApplicationStore = create<ApplicationStore>((set) => ({
  applicationProps: { tokenExpired: false },
  setApplicationProps: (applicationProps: ApplicationStoreProps) =>
    set(() => ({ applicationProps })),
}));
